import { AppState } from './../../../../core/reducers/index';
import { FormControl, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';

import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { User, currentUser } from '@app/core/auth';
import { Store, select } from '@ngrx/store';
import { environment } from '@app/../environments/environment';
import { UsersService, RoleService } from '@app/api/api';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map, debounceTime } from 'rxjs/operators';

interface UserRoleResponse {
  name?: string;
}

interface UserInfoResponse {
  id?: string;
  full_name?: string;
  email?: string;
  phone?: string;
  gender?: boolean;
  birthday?: string | Date;
  code?: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

@Component({
  selector: 'meu-app-basic-info',
  templateUrl: './app-basic-info.component.html',
  styleUrls: ['./app-basic-info.component.scss'],
})
export class AppBasicInfoComponent implements OnInit, OnChanges {
  @Output() isEditing = new EventEmitter();
  isCustomerCodeReadonly = false;
  constructor(
    private userService: UsersService,
    private roleService: RoleService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService
  ) {}
  lstDate: any = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
    27, 28, 29, 30, 31,
  ];
  lstYear: any = [];
  lstYearDraft: any = [];
  lstMonth: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  checkChangePassword: boolean = false;
  dateOfBirth: any = '';
  monthOfBirth: any = '';
  yearOfBirth: any = '';
  showOld: boolean = false;
  showNew: boolean = false;
  showReNew: boolean = false;
  user$: Observable<User>;
  public keyUp = new Subject<KeyboardEvent>();
  public controlSearch: FormControl = new FormControl();
  @Input() myInfo: any;
  @Input() openFromManageUser = false;
  userRole: any = null;
  roleName: string = '';
  basicInfoForm = new FormGroup({
    full_name: new FormControl('', [Validators.required]),
    code: new FormControl(''),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$'),
    ]),
    phone: new FormControl('', [Validators.required]),
    gender: new FormControl('', [Validators.required]),
    date: new FormControl('', [Validators.required]),
    month: new FormControl('', [Validators.required]),
    year: new FormControl('', [Validators.required]),
    birthday: new FormControl(''),
  });
  hasFormErrors: boolean = false;
  currentPassword: any = '';
  newPassword: any = '';
  reNewPassword: any = '';

  ngOnChanges() {
    this.calculateYear();

    if (this.myInfo) {
      this.patchBasicInfoForm(this.myInfo);
      if (this.myInfo.id) {
        this.getUserRole(this.myInfo.id);
      }
    }

    this.syncCustomerCodeEditState();
  }
  ngOnInit() {
    if (this.openFromManageUser) {
      this.getUserById(this.myInfo.id);
      if (this.myInfo && this.myInfo.id) {
        this.getUserRole(this.myInfo.id);
      }
    } else {
      this.user$ = this.store.pipe(select(currentUser));
      this.user$.subscribe((user) => {
        this.myInfo = user;
        if (this.myInfo && this.myInfo.id) {
          this.getUserRole(this.myInfo.id);
        }
      });

      if (this.myInfo) {
        this.getUserById(this.myInfo.id);
        if (this.myInfo.id) {
          this.getUserRole(this.myInfo.id);
        }
      }
    }

    this.calculateYear();
  this.syncCustomerCodeEditState();
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(300)
      )
      .subscribe((value) => {
        this.lstYear = [];
        const foundElement = this.lstYearDraft.find((element) => element.toString().includes(value));
        this.lstYear = foundElement ? [foundElement] : [];
      });
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      // '0' - '9'
      event.preventDefault();
    }
  }
  getUserById(id: string) {
    this.userService.apiUsersIdGet(id).subscribe((res: ApiResponse<UserInfoResponse>) => {
      if (res.success) {
        this.patchBasicInfoForm(res.data);
      }
    });
  }
  search(event) {}
  updateUserInfoMobile() {
    if (this.openFromManageUser) {
      this.updateUserInfo();
      return;
    }
    const controls = this.basicInfoForm.controls;
    if (this.basicInfoForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    } else {
      if (!this.myInfo || !this.myInfo.id) {
        return;
      }
      const payload = this.buildUpdatePayload();
      this.userService.apiUsersIdPut(this.myInfo.id, payload).subscribe((res) => {
        if (res.success) {
          $('.userNameHeader').text(res.data.full_name);
          if (this.checkChangePassword) {
            if (
              this.currentPassword != '' &&
              this.newPassword != '' &&
              this.reNewPassword != '' &&
              this.currentPassword === this.newPassword
            ) {
              this.userService
                .apiUsersChangePasswordPost(
                  this.basicInfoForm.value.email,
                  this.currentPassword,
                  this.newPassword
                )
                .subscribe((resChangePassword) => {
                  if (resChangePassword.success) {
                    this.toastr.success('Cập nhật mật khẩu thành công');
                    this.router.navigate(['/myprofile']);
                  }
                });
            } else {
              this.toastr.success('Cập nhật thành công');
              this.hasFormErrors = true;
            }
          } else {
            this.router.navigate(['/myprofile']);
          }
        }
      });
    }
  }
  updateUserInfo() {
    const controls = this.basicInfoForm.controls;
    if (this.basicInfoForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    } else {
      if (!this.myInfo || !this.myInfo.id) {
        return;
      }
      const payload = this.buildUpdatePayload();
      this.userService.apiUsersIdPut(this.myInfo.id, payload).subscribe((res) => {
        if (res.success) {
          if (!this.openFromManageUser) {
            $('.userNameHeader').text(res.data.full_name);
          }

          if (this.checkChangePassword) {
            if (this.currentPassword != '' && this.newPassword != '' && this.reNewPassword != '') {
              if (this.reNewPassword === this.newPassword) {
                this.userService
                  .apiUsersChangePasswordPost(
                    this.basicInfoForm.value.email,
                    this.currentPassword,
                    this.newPassword
                  )
                  .subscribe((resChangePassword) => {
                    if (resChangePassword.success) {
                      this.toastr.success('Cập nhật mật khẩu thành công');
                    } else {
                      this.toastr.success(resChangePassword.message, 'Thao tác thất bại');
                    }
                  });
              } else {
                this.hasFormErrors = true;
              }
            } else {
              this.hasFormErrors = true;
            }
          } else {
            this.toastr.success('Cập nhật thành công');
            this.isEditing.emit(true);
          }
        }
      });
    }
  }
  calculateYear() {
    let today = new Date();
    for (let i = 1955; i <= today.getFullYear(); i++) {
      this.lstYear.push(i);
    }
    this.lstYearDraft = this.lstYear.slice();
  }
  calculateDayOfMonth(days) {
    let today = new Date();
    this.lstDate = [];
    for (let i = 1; i <= days; i++) {
      this.lstDate.push(i);
    }
    if (this.dateOfBirth > days) {
      this.dateOfBirth = '';
    }
  }
  checkDateChoosed() {
    let daysOfMonth = new Date(this.yearOfBirth, this.monthOfBirth, 0).getDate();
    this.calculateDayOfMonth(daysOfMonth);
  }

  private getBirthDateParts(birthday: string | Date | undefined) {
    if (!birthday) {
      return {
        date: '',
        month: '',
        year: '',
      };
    }

    const parsedBirthday = new Date(birthday);
    if (Number.isNaN(parsedBirthday.getTime())) {
      return {
        date: '',
        month: '',
        year: '',
      };
    }

    return {
      date: parsedBirthday.getDate(),
      month: parsedBirthday.getMonth() + 1,
      year: parsedBirthday.getFullYear(),
    };
  }

  private normalizeCustomerCode(code: string | undefined): string {
    const normalizedCode = (code || '').trim();
    return normalizedCode || this.getDefaultCustomerCode();
  }

  private getDefaultCustomerCode(): string {
    const fallback = 'không có';
    const translated = this.translate.instant('PROFILE.USER_INFO.DETAIL.NO_CUSTOMER_CODE');
    return translated && translated !== 'PROFILE.USER_INFO.DETAIL.NO_CUSTOMER_CODE'
      ? translated
      : fallback;
  }

  private patchBasicInfoForm(userInfo: UserInfoResponse): void {
    const birthdayParts = this.getBirthDateParts(userInfo.birthday);

    this.basicInfoForm.patchValue({
      full_name: userInfo.full_name,
      code: this.normalizeCustomerCode(userInfo.code),
      email: userInfo.email,
      phone: userInfo.phone,
      gender: userInfo.gender,
      birthday: userInfo.birthday,
      date: birthdayParts.date,
      month: birthdayParts.month,
      year: birthdayParts.year,
    });
  }

  private buildUpdatePayload() {
    const formValue = this.basicInfoForm.getRawValue();
    const birthday = formValue.year + '-' + formValue.month + '-' + formValue.date;

    const normalizedCode = this.normalizeCustomerCode(formValue.code);

    this.basicInfoForm.patchValue({
      birthday,
      code: normalizedCode,
    });

    return {
      ...formValue,
      birthday,
      code: normalizedCode,
    };
  }

  private syncCustomerCodeEditState(): void {
    const roleNameRaw = `${(this.userRole && this.userRole.name) || this.roleName || ''}`.toLowerCase();
    const isCustomerRole = roleNameRaw.includes('customer') || roleNameRaw.includes('khách hàng');
    this.isCustomerCodeReadonly = !this.openFromManageUser && isCustomerRole;

    const codeControl = this.basicInfoForm.get('code');
    if (!codeControl) {
      return;
    }

    if (this.isCustomerCodeReadonly) {
      codeControl.disable({ emitEvent: false });
    } else {
      codeControl.enable({ emitEvent: false });
    }
  }

  getUserRole(userId: string) {
    this.userService.apiUsersIdRolesGet(userId).subscribe((res: ApiResponse<UserRoleResponse>) => {
      if (res.success) {
        this.userRole = res.data;
        if (this.userRole && this.userRole.name) {
          if (this.userRole.name === 'No role assigned') {
            this.roleName = this.translate.instant('PROFILE.USER_INFO.DETAIL.NO_ROLE');
          } else {
            this.roleName = this.userRole.name;
          }
        } else {
          this.roleName = this.translate.instant('PROFILE.USER_INFO.DETAIL.NO_ROLE');
        }
      } else {
        this.roleName = this.translate.instant('PROFILE.USER_INFO.DETAIL.NO_ROLE');
      }

      this.syncCustomerCodeEditState();
    }, (error) => {
      console.log('Error getting user role:', error);
      this.roleName = this.translate.instant('PROFILE.USER_INFO.DETAIL.NO_ROLE');
      this.syncCustomerCodeEditState();
    });
  }
}
